import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Divider, Link, Popover, SearchInput, Text } from '@reveni-io/reveni-ui'

import useReturnPortalSelector from './hooks/useReturnPortalSelector/useReturnPortalSelector'
import NoReturnPortalsFound from './NoReturnPortalsFound/NoReturnPortalsFound'
import ReturnPortal from './ReturnPortal/ReturnPortal'
import { filterReturnPortalsBySearch } from './helpers'
import * as Styles from './styles'

const ReturnPortalSelector = ({ returnPortals = [], onChangeReturnPortal, selectedReturnPortal, showMenu }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const {
    anchorEl,
    onOpenPopover,
    onClosePopover,
    searchValue,
    setSearchValue,
    isReturnPortalSelected,
    returnPortalsToRender,
    ref,
    hasMultipleReturnPortals,
    isOpen,
  } = useReturnPortalSelector({
    returnPortals,
    selectedReturnPortal,
  })

  return (
    <Styles.MainContainer ref={ref}>
      <Styles.SelectedStoreLogo
        src={selectedReturnPortal?.theme?.returns_favicon_url || selectedReturnPortal?.theme?.logo_url}
        alt="store_logo"
      />
      <Styles.Container hasMultipleStores={hasMultipleReturnPortals}>
        <Styles.StoreSelectorContainer>
          <Text type="bodyMBold">{selectedReturnPortal?.internal_name}</Text>
          <Styles.StoreDomainContainer showMenu={showMenu}>
            <Link href={`https://${selectedReturnPortal?.store?.domain}`}>
              <Text type="linkXs" tag="a" color={theme.colors.text.link.default}>
                {selectedReturnPortal?.store?.domain}
              </Text>
            </Link>
          </Styles.StoreDomainContainer>
        </Styles.StoreSelectorContainer>
        {hasMultipleReturnPortals && (
          <Styles.CustomCaretDownIcon isOpen={isOpen} onClick={onOpenPopover} size={24} weight="thin" />
        )}
        <Popover
          open={isOpen}
          anchorEl={anchorEl}
          onClose={onClosePopover}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        >
          <Styles.SearchContainer>
            <SearchInput
              placeholder={t('Buscar tienda')}
              fullWidth
              onSearch={filterReturnPortalsBySearch}
              onChangeValue={setSearchValue}
              value={searchValue}
            />
          </Styles.SearchContainer>
          <Divider />
          <Styles.StoresContainer>
            {returnPortalsToRender?.length > 0 ? (
              returnPortalsToRender.map(portal => (
                <ReturnPortal
                  key={portal.id}
                  portal={portal}
                  onChangeReturnPortal={onChangeReturnPortal}
                  isSelected={isReturnPortalSelected(portal.id)}
                />
              ))
            ) : (
              <NoReturnPortalsFound />
            )}
          </Styles.StoresContainer>
        </Popover>
      </Styles.Container>
    </Styles.MainContainer>
  )
}

export default ReturnPortalSelector
